import { ChangeDetectorRef, Component } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, tap } from 'rxjs';
import { FileIngestionConfigService } from '../../services/file-ingestion-config/file-ingestion-config.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { MESSAGE_TITLE } from '../../enums/message-title';

@Component({
    selector: 'file-ingestion-config',
    templateUrl: './file-ingestion-config.component.html',
    styleUrl: './file-ingestion-config.component.css',
})
export class FileIngestionConfigComponent {
    isSideBarVisible: boolean = false;
    isDeleteModalVisible: boolean = false;
    toDeleteItem: any;
    editedId: string = '';
    selectedCreditorId: string = '';
    creditorCompanyName: string = '';
    fileIngestionConfigs!: any[];

    isHideAddNew: boolean = false;

    overwriteAmountDueOnly: boolean = true;
    missingInvoicesStatusId: any = 'NULL';
    hasSearch: boolean = false;

    public constructor(
        private etlIngestionService: EtlIngestionService,
        public appService: AppService,
        private fileIngestionConfigService: FileIngestionConfigService,
        private cdr: ChangeDetectorRef,
    ) {}
    public invoiceStatuses = [
        {
            id: 'NULL',
            label: 'NULL',
        },
        {
            id: 0,
            label: 'Awaiting Payment',
        },
        {
            id: 1,
            label: 'On Payment Plan',
        },
        {
            id: 2,
            label: 'Paid',
        },
        {
            id: 3,
            label: 'Voided',
        },
        {
            id: 4,
            label: 'Defaulted',
        },
        {
            id: 5,
            label: 'Closed',
        },
        {
            id: 6,
            label: 'Pending Payment',
        },
    ];

    getInvoiceStatusLabel = (missingInvoicesStatusId: number) => {
        return (
            this.invoiceStatuses.find(
                (i: any) => i.id === missingInvoicesStatusId,
            )?.label ?? 'NULL'
        );
    };

    ngOnInit() {}

    get hasTableData(): boolean {
        return isArrayWithData(this.fileIngestionConfigs);
    }

    onSelectCreditor(event: any) {
        this.fileIngestionConfigs = [];
        this.selectedCreditorId = event.CreditorId;
        this.creditorCompanyName = event.CompanyName;

        this.search();
    }

    search() {
        if (!!this.selectedCreditorId) {
            this.appService.isShowPageSpinner = true;
            this.fileIngestionConfigs = [];
            this.fileIngestionConfigService
                .get(this.selectedCreditorId)
                .pipe(
                    tap((res: any) => {
                        if (!!res) {
                            this.fileIngestionConfigs = [res];
                            this.isHideAddNew = true;
                        } else {
                            this.isHideAddNew = false;
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                        this.hasSearch = true;
                    }),
                )
                .subscribe();
        }
    }

    onOpenSideBar(
        id: string = '',
        overwriteAmountDueOnly: boolean = true,
        missingInvoicesStatusId: any = 'NULL',
    ) {
        if (!!this.selectedCreditorId) {
            this.editedId = id;
            this.overwriteAmountDueOnly = overwriteAmountDueOnly;
            this.missingInvoicesStatusId = missingInvoicesStatusId;
            this.isSideBarVisible = true;
        } else {
            this.appService.showSelectCreditorMessage();
        }
    }

    onOpenDeleteModal(item: any) {
        this.toDeleteItem = item;
        this.isDeleteModalVisible = true;
    }

    onConfirmDelete() {
        if (!!this.toDeleteItem) {
            this.appService.isShowPageSpinner = true;

            this.fileIngestionConfigService
                .delete(this.toDeleteItem)
                .pipe(
                    tap(() => {
                        this.appService.showCommonMessageDialog(
                            MESSAGE_TITLE.SUCCESS,
                            'File Ingestion Config has been successfully deleted.',
                        );

                        this.fileIngestionConfigs =
                            this.fileIngestionConfigs.filter(
                                (i: any) =>
                                    i.FileIngestionConfigId !==
                                    this.toDeleteItem.FileIngestionConfigId,
                            );
                        this.isDeleteModalVisible = false;
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                    }),
                )
                .subscribe();
        }
    }

    onSave() {
        this.appService.isShowPageSpinner = true;

        const missingInvoicesStatusId =
            this.missingInvoicesStatusId === 'NULL'
                ? null
                : this.missingInvoicesStatusId;

        if (!!this.missingInvoicesStatusId) {
            if (!this.editedId && !!this.selectedCreditorId) {
                this.fileIngestionConfigService
                    .post(
                        this.selectedCreditorId,
                        this.overwriteAmountDueOnly,
                        missingInvoicesStatusId,
                    )
                    .pipe(
                        tap((res: any) => {
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'File Ingestion Config has been successfully created.',
                            );

                            this.isSideBarVisible = false;
                            setTimeout(() => {
                                this.search();
                            }, 500);
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {
                            this.appService.isShowPageSpinner = false;
                        }),
                    )
                    .subscribe();
            } else {
                this.fileIngestionConfigService
                    .put(
                        this.editedId,
                        this.overwriteAmountDueOnly,
                        missingInvoicesStatusId,
                    )
                    .pipe(
                        tap(() => {
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'File Ingestion Config has been successfully updated.',
                            );
                            this.isSideBarVisible = false;

                            let newFileIngestionConfig =
                                this.fileIngestionConfigs[0];
                            newFileIngestionConfig.overwriteAmountDueOnly =
                                this.overwriteAmountDueOnly;
                            newFileIngestionConfig.missingInvoicesStatusId =
                                this.missingInvoicesStatusId;

                            this.fileIngestionConfigs = [
                                newFileIngestionConfig,
                            ];
                            this.cdr.detectChanges();

                            //do search since above code ain't working
                            setTimeout(() => {
                                this.search();
                            }, 500);
                        }),
                        catchError(this.appService.handleError),
                        finalize(() => {}),
                    )
                    .subscribe();
            }
        } else {
            this.appService.showCommonMessageDialog(
                'Validation',
                'Please input Missing Invoices Status Id',
            );
        }
    }
}
